import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

export const useDashboardListingFolding = createGlobalState({
  key: "dashboardListingFolding",
  defaultValue: false,
  storage: "local",
  type: io.boolean,
  scoped: false,
});
